const locale = [window.navigator.userLanguage || window.navigator.language]; // first one is for IE/windows
export let getTime = () => Math.floor(new Date().getTime() / 1000);
export const numberFormat = new Intl.NumberFormat(locale, {
  maximumFractionDigits: 3
});
export const numberFormatTwoFractions = new Intl.NumberFormat(locale, {
  maximumFractionDigits: 2
});

const localeOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
};

export const localeOptionsTime = {
  hour: '2-digit',
  minute: '2-digit'
};

export const localeOptionsTimeWithSecond = {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit'
};

const localeOptionsDays = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};

export const localTimeFormat = ({ timezone }) => {
  if (!timezone) {
    return new Intl.DateTimeFormat(locale, localeOptionsTime);
  }
  return new Intl.DateTimeFormat(locale, {
    ...localeOptionsTime,
    timeZone: timezone
  });
};

export const localTimeFormatWithSecond = ({ timezone }) => {
  if (!timezone) {
    return new Intl.DateTimeFormat(locale, localeOptionsTimeWithSecond);
  }
  return new Intl.DateTimeFormat(locale, {
    ...localeOptionsTimeWithSecond,
    timeZone: timezone
  });
};

export const localDateFormat = ({ timezone }) => {
  if (!timezone) {
    return new Intl.DateTimeFormat(locale, localeOptions);
  }
  return new Intl.DateTimeFormat(locale, {
    ...localeOptions,
    timeZone: timezone
  });
};

export const localDateFormatDays = ({ timezone }) => {
  if (!timezone) {
    return new Intl.DateTimeFormat(locale, localeOptionsDays);
  }
  return new Intl.DateTimeFormat(locale, {
    ...localeOptionsDays,
    timeZone: timezone
  });
};



// WEBPACK FOOTER //
// ./src/helper/dateFormat.js